<template>
  <v-container
      style="width: 100%; padding-top: 4%; padding-bottom: 4%;"
      class="text-left"
    >
      <v-row class="mb-5" justify="center">
        <v-col md="3" class="text-right mr-5">
          <sub class="header">ESCRÍBENOS</sub>
        </v-col>
        <v-col md="3">
          <caption class="email">info@optimalmarkets.cl</caption>
          <body-1 class="body">
            <a href="mailto:info@optimalmarkets.cl" style="text-decoration: none;">
              <v-icon color="#161c2d">mdi-email-outline</v-icon>
            </a>
          </body-1>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}

.email {
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 1.8rem;
  color: #161c2d;
}

.header {
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #161c2d;
}

</style>



// WEBPACK FOOTER //
// src/components/ContactLarge.vue